import Form from '../../../../../types/api/form'

export type NumberingMode = 'new' | 'keep' | 'combined'

/** keepNum учитывается только в режиме combined */
export function shouldKeepNum(mode: NumberingMode, keepNum: boolean): boolean {
    if (mode === 'keep') return true
    if (mode === 'new') return false
    return keepNum
}

/** До save orderId ещё нет — для новых номеров плейсхолдер, assignedNum появляется после save */
export function draftNumPreview(
    mode: NumberingMode,
    keepNum: boolean,
    form?: Form,
    assignedNum?: string
): string {
    if (shouldKeepNum(mode, keepNum)) return form?.num || '—'
    return assignedNum || 'присвоится при сохранении'
}
